export default __webpack_public_path__ + "static/media/goal1.43ec04f3.webp";